/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    array,
} from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ResponsiveImage from '../../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';

const useStyles = makeStyles((theme) => ({
    bannerImage: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    },
    imageContainer: {
        display: 'grid',
        gridTemplateColumns: '1fr',
    },
    imageWrapper: {
        gridTemplateColumns: '1fr 1fr',
        columnGap: '16px',
        [theme?.breakpoints?.down('600')]: {
            gridTemplateColumns: '1fr',
            columnGap: '0px',
            rowGap: '32px',
        },
    },

}));

const StoryBanner = ({
    data,
}) => {
    if (data?.image?.length === 0) { return null; }
    const classes = useStyles();
    return (
        <div className={`${classes.imageContainer} ${data.image.length > 1 ? classes.imageWrapper : ''}`}>
            {data.image.map((item) => (
                <ResponsiveImage
                    className={classes.bannerImage}
                    path={item.url}
                    alt={item.title}
                />
            ))}
        </div>
    );
};

StoryBanner.propTypes = {
    data: array.isRequired,
};

export default StoryBanner;
